
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BestEffortSupport',
  props: {
    supportTierCopy: {
      type: String,
      required: true
    }
  }
})
